import CurrentSensorReliability from "./CurrentSensorReliability/CurrentSensorReliability";
import {
    TabAnimationSettingsModel,
    TabComponent,
    TabItemDirective,
    TabItemsDirective
} from "@syncfusion/ej2-react-navigations";
import HistoricalSensorReliability from "./HistoricalSensorReliability/HistoricalSensorReliability";

function FleetSensorReliability() {
    
    const tabAnimation: TabAnimationSettingsModel = {
        previous: {effect: 'None'},
        next: {effect: 'None'}
    };
    
    const currentSensorReliability = () => <div style={{backgroundColor: 'white'}}><CurrentSensorReliability/></div>;
    
    return (
        <div style={{margin: '1em', backgroundColor: 'white'}}>
            <TabComponent heightAdjustMode={"Auto"} animation={tabAnimation} >
                <TabItemsDirective>
                    <TabItemDirective headerText="Current Sensor Reliability" content={CurrentSensorReliability}/>
                    <TabItemDirective headerText="Historical Sensor Reliability" content={HistoricalSensorReliability}/>
                </TabItemsDirective>
            </TabComponent>
        </div>
    );
}

export default FleetSensorReliability;